export function normalizeApplicantDetails(value) {
  if (!value) return null;
  const candidate = value.candidateDetails || value.candidate;
  const application = value.appliedJobInfo || value;
  const job = value.jobDetails || value.job;
  if (!candidate) return null;
  const candidateId = candidate._id || application.candidateId;
  return {
    ...value,
    ...application,
    candidateId,
    candidateDetails: {
      ...candidate,
      _id: candidateId,
      userId: candidate.userId || application.candidateUserId || value.candidateUserId,
    },
    jobDetails: job,
    jobId: job?._id || application.jobId,
    jobRequirementId: value.jobRequirementId || job?.jobRequirementId,
  };
}

export function getApplicantChatContext(value) {
  const data = normalizeApplicantDetails(value);
  const candidate = data?.candidateDetails;
  return {
    jobId: data?.jobId,
    receiverDetails: {
      ...candidate,
      userId: candidate?.userId,
      name: [candidate?.firstName, candidate?.lastName].filter(Boolean).join(" "),
    },
  };
}
